module.exports = __webpack_public_path__ + "static/media/pytorchlogo.682b59a5.png";